// export const ENDPOINT = 'http://localhost:5000/'
export const ENDPOINT = 'https://blue-chat-619.herokuapp.com/'
